import { useMutation, useQueryClient } from 'react-query';
import { api, ENDPOINTS, useToken } from '~/api';

export const useUpdateCuratedExamples = () => {
    const queryClient = useQueryClient();
    const { token } = useToken();

    return useMutation(payload => api.patch(
        ENDPOINTS.CURATED_DESCRIPTORS,
        payload,
        { headers: { Authorization: token } }
    ), {
        onSuccess: () => {
            queryClient.invalidateQueries(['curatedDescriptor'])
        },
    });
};
